import React from 'react';

const ROTATION = { down: 0, up: 180, left: 90, right: -90 };

const LineChevronSvg = ({
  size = 20,
  direction = 'down',
}: {
  size?: number;
  direction?: keyof typeof ROTATION;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ transform: `rotate(${ROTATION[direction]}deg)` }}
    aria-hidden
  >
    <path d="M5 7.5L10 12.5L15 7.5" />
  </svg>
);

export default LineChevronSvg;
